import styled from '@emotion/styled';


export const StyledSidebarContainer = styled.div`
    display: flex;
    height: 100%;
    max-width: 80px;
    z-index: 999999;
`;